import CategorySaga from './CategorySaga'
import CourseSaga from './CourseSaga'
import DisabilitySaga from './DisabilitySaga'
import DisciplineSaga from './DisciplineSaga'
import EducationSaga from './EducationSaga'
import ExamSaga from './ExamSaga'
import HelperSaga from './HelperSaga'
import QuizCategorySaga from './QuizCategorySaga'
import QuizQuestionSaga from './QuizQuestionSaga'
import QuizSaga from './QuizSaga'
import SubjectSaga from './SubjectSaga'
import TagSaga from './TagSaga'
import TenantSaga from './TenantSaga'
import UserSaga from './UserSaga'
import { fork } from 'redux-saga/effects'

export default function * sagas() {
  yield fork(UserSaga().watcher)
  yield fork(ExamSaga().watcher)
  yield fork(CategorySaga().watcher)
  yield fork(DisabilitySaga().watcher)
  yield fork(CourseSaga().watcher)
  yield fork(DisciplineSaga().watcher)
  yield fork(HelperSaga().watcher)
  yield fork(EducationSaga().watcher)
  yield fork(SubjectSaga().watcher)
  yield fork(TagSaga().watcher)
  yield fork(QuizCategorySaga().watcher)
  yield fork(QuizQuestionSaga().watcher)
  yield fork(QuizSaga().watcher)
  yield fork(TenantSaga().watcher)
}